Controller = App.loadClass 'core::Angular/Controller'

class exports.TransportationController extends Controller
    constructor: (@scope, @transitions, @modal, @http, @service, @state, _1, _2, _3, @ngModal) ->
        super

        @selectedGins = []

        @service.onDataLoaded @scope, () =>
            @buyerLocation = @service.fpcResult.data.buyer_location
            # make sure the buyer locations load afterwards so that the selection code runs
            @loadSelectedGins().then () =>
                @loadBuyerLocations()
            .catch (err) =>
                @loadBuyerLocations()

            @loadStorageLocations()

            @scope.$watchGroup [
                'service.fpcResult.data.stored_on_farm'
                'service.fpcResult.data.storage_location'
                'service.fpcResult.data.delivered_to_buyer'
                'service.fpcResult.data.buyer_location'
            ], @calculateDistance

    calculateDistance: () =>
        @http.post "backend/grower/fieldprint/#{@service.fpcResult.id}/calculate-distance", @service.fpcResult.data
        .then (response) =>
            if not response.data and @service.fpcResult.data?
                @service.fpcResult.data.distance = null
                return

            if @service.fpcResult?.data?
                @service.fpcResult.data.distance = parseFloat(response.data).toFixed(1)

    addLocation: (type) =>
        @service.save @service.fpcResult.id
        if type is 'buyer'
            @state.go 'grower.buyerlocation',
                locationId: null,
                fpcResultId: @service.fpcResult.id
                step: @service.currentStepIndex + 1
        else
            @state.go 'grower.operation.add-storage',
                fpcId: @service.fpcResult.id
                fpcStep: @service.currentStepIndex + 1

    editLocation: (type) =>
        if type is 'buyer'
            @state.go 'grower.buyerlocation',
                locationId: @service.fpcResult.data.buyer_location
                fpcResultId: @service.fpcResult.id
                step: @service.currentStepIndex + 1
        else
            @http.get "backend/grower/storage-locations/#{@service.fpcResult.data.storage_location}"
            .then (response) =>
                @state.go 'grower.operation.edit-storage',
                    storageLocation: response.data
                    fpcId: @service.fpcResult.id
                    fpcStep: @service.currentStepIndex + 1


    deleteLocation: (type) =>
        newscope = @scope.$new()
        # newscope.title = "Delete #{_.capitalize(type)} Location"
        newscope.item_name = "#{_.capitalize(type)} Location"
        newscope.delete = () =>
            if type is 'buyer'
                return @http.post 'backend/grower/buyer-location/delete', location: @service.fpcResult.data.buyer_location, fpcResultId: @service.fpcResult.id
            else
                return @http.post 'backend/grower/operation/delete-location', locations: [{ id: @service.fpcResult.data.storage_location }], fpcResultId: @service.fpcResult.id

        dlg = @modal.open
            templateUrl: 'backend/portal/home/delete-dialog'
            controller: 'DeleteDialogController'
            scope: newscope

        dlg.result.then () =>
            if type is 'buyer'
                @service.fpcResult.data.buyer_location = null
                @loadBuyerLocations()
            else
                @service.fpcResult.data.storage_location = null
                @loadStorageLocations()

    loadSelectedGins: () =>
        @http.get "backend/grower/selected-gin-lists?year=#{@service.year}&field_id=#{@service.field}"
        .then (response) =>
            return if response.data.length is 0
            @selectedGins = response.data[0]?.gins
            if @service.fpcResult.data.buyer_location and not @ginIsInList()
                @http.get "backend/grower/api-gins/#{@service.fpcResult.data.buyer_location}?year=#{@service.year}&field_id=#{@service.field}"
                .then (response) =>
                    @selectedGins.push response.data

    loadBuyerLocations: () =>
        @http.post 'backend/grower/buyer-location/load-all', { fpcResultId: @service.fpcResult.id }
        .then (response) =>
            @buyerLocations = []

            # don't store soft deleted locations
            for location in response.data.data
                @buyerLocations.push location if not location.deleted
            # try to set the selected location (if one exists)
            # its important to iterate response.data.data and not @buyerLocations because we do not store soft deleted locations in @buyerLocations
            for location in response.data.data when location.selected?
                @service.fpcResult.data.buyer_location = location.id

            if @service.fpcResult?.data? and not @service.fpcResult.data.buyer_location?
                if @selectedGins.length is 1 and @service.config[@service.crop].steps.value.Transportation.value.transportation.value.buyer_location.value.is_gin?.value
                    @service.fpcResult.data.buyer_location = @selectedGins[0].id
                else if @buyerLocations.length is 1
                    @service.fpcResult.data.buyer_location = @buyerLocations[0].id

    loadStorageLocations: () =>
        @http.get('backend/grower/operation/load-storage-locations').then (response) =>
            if @service.fpcResult?.data?
                @storageLocations = response.data.data.filter((location) => not location.is_manure)
                if @storageLocations.length is 1 and not @service.fpcResult.data.storage_location?
                    @service.fpcResult.data.storage_location = @storageLocations[0].id

    openSelectedGins: () =>
        @ngModal.openSelectedGins(@service.year, @service.fpcResult.field).modalRef.result.then (gins) =>
            @selectedGins = gins
            if not @ginIsInList()
                @service.fpcResult.data.buyer_location = null
        .catch _.noop

    getGinName: (gin) =>
        return 'Loading...' unless gin?.name?
        first = [ gin.address, gin.city ].filter((v) -> v).join ' '
        second = [ gin.county?.state.code, gin.zip ].filter((v) -> v).join ' '
        address = [ first, second ].filter((v) -> v).join ', '
        return "#{gin.name} (#{@getStatusText(gin)}) (#{address})"

    ginIsInList: () => @selectedGins.some((gin) => gin.id is @service.fpcResult.data.buyer_location)

    getStatusText: (gin) ->
        switch gin.status_type
            when 'not_connected' then 'Gin Not Connected'
            when 'connected' then 'Gin Connected'
            when 'connected_without_fields_available' then 'Gin Connected'
            when 'no_field_connected' then 'Gin Not Connected'
            when 'field_connected' then 'Field Connected'
            when 'pending_review' then'Pending Review'
            when 'connection_na' then 'Connection N/A'
            else 'Connection N/A' # TODO: Fix bug where status can be undefined, causing (undefined)
